import { z } from 'zod'

/**
 * Kasutaja teemaeelistus. `system` järgib OS-i (prefers-color-scheme); `light` ja
 * `dark` on kindel valik. Salvestub users.theme_preference + localStorage.
 */
export const THEME_PREFERENCES = ['system', 'light', 'dark'] as const
export type ThemePreference = (typeof THEME_PREFERENCES)[number]
export const themePreferenceSchema = z.enum(THEME_PREFERENCES)
export const isThemePreference = (value: unknown): value is ThemePreference =>
    themePreferenceSchema.safeParse(value).success
